import { AuthState } from '@/state'
import { useComputed } from '@preact/signals-react'

export default function TopbarUserInfo() {
  const userData = useComputed(() => {
    const { firstName, lastName } = AuthState.currentUser.value

    return {
      fullName: `${firstName} ${lastName}`,
      currentRole: AuthState.currentRole.value?.name,
    }
  })

  return (
    <div className='topbar-user-info'>
      <div className='user-name'>{userData.value.fullName}</div>
      <div className='current-role'>{userData.value.currentRole}</div>
    </div>
  )
}
